import React from 'react';
import {HashLink as Link} from "react-router-hash-link";
import BBExternalLink from "../../components/customBreachBits/accents/BBExternalLink";


const BRfBizInitialTourTechnical = {
    url: `/board/BreachRisk/Business/Report/TechData`,
    type: `tutorial`,
    user: {
        first_login: true,
        // first_time_on_page: true,
        // manager: true,
    },
    entity: {
        verified_ownership: true,
        // subscription: "Business",
        // subLevel: ["pro", "premium"],
        hasScores: true,
    },
    openingModal: {
        icon: null,
        heading: "Tour BreachRisk™ Technical?",
        description: <div className={"text-center"}>
            <p>
                Don't just monitor your risk, take control of it. BreachRisk™ Technical is designed to enable your technical team to understand the full context of risk and to efficiently find, fix, and verify issues related to the threats that we've detected.
            </p>
        <p>
            This page contains all the elements of your IT infrastructure we have been able to detect. Find detailed tables listing active hosts, known IP addresses, Common Vulnerabilities, and more.
        </p>
    </div>},
    tourSteps: {
        1:{
            step: 1,
            title: "Threat Vectors Detected",
            // placement: "top-start",
            content: <>
                <p>This table is a focal point in your journey to eliminate and mitigate threats. It contains all identified threat vectors and gives you tools to investigate each threat further and see the results of our continuous penetration testing. </p>

            </>,
            scrollToElement: "#tourStepThreatsTechTable",
            anchorEl: "#tourStepBRReportVectorsTable",
            last: false,
        },
        3: {
            step: 3,
            title: "Danger Level",
            placement: "left",
            content:<>
                <p>Each threat has it's own danger level which describes the likelihood and impact of an attacker using this specific threat against your company.</p>
                {/*<p> The higher the danger level the more serious a threat</p>*/}
                    </>
                // <p>
                //     You'll find the overview for threats found during your latest scoring cycle. Use these charts to easily determine the state of your security.
                // Start by identifying the danger level of any individual threat.</p>
            ,
            scrollToElement: false,
            anchorEl: "#tourDangerLevel",
            element: document.getElementsByClassName("tourDangerLevelCol"),
            last: false,
            // element: document.getElementById(),
        },
        8: {
            step: 8,
            title: "Threat Details and Inspect Host",
            placement: "left",
            content: <>
                <p>Threat Details allows you to see this threat from the hacker's perspective. With penetration testing enabled, you can see the results and measure the effectiveness of your defenses. </p>
                <p>Inspect Host allows you to pinpoint threats we've identified. Use it to find, fix, and then verify corrective and mitigating actions. </p>
                </>,
            scrollToElement: false,
            anchorEl: "#tourAnchorElToTryToHighlight",
            element: document.getElementsByClassName("tourTryToHighlightElement"),
            last: false,
        },
        7: {
            step: 7,
            title: "Issue Status",
            placement: "left",
            content: "Communicate with your team on the status of any given threat. Setting the status will be visible to all users in your company and gives you the ability to track a threat across testing cycles.",
            anchorEl: "#tourStepSetStatus",
            scrollToElement: false,
            element: document.getElementsByClassName("tourSetStatusCol"),
            last: false,
        },
        6: {
            step: 6,
            title: "Comments",
            placement: "left",
            content:
                <p>Leave comments for yourself or your team. Comments let you keep track of your investigation or it allows you to note your company's current action item for a given threat.</p>,
            anchorEl: "#tourStepLeaveAComment",
            scrollToElement: false,
            element: document.getElementsByClassName("tourStepCommentCol"),
            last: false,
        },
        4: {
            step: 4,
            title: "Scope",
            placement: "left",
            content: <>
                <p>
                    Continuous penetration testing is designed to always be enabled and to adhere to our <Link smooth to={'/board/userguide'}className={"text-white"}><u> safety promise,</u></Link> however, if you would like certain threats to not be tested, you can use the scope feature.
                </p>
            </>,
            anchorEl: "#tourStepThreatScope",
            scrollToElement: false,
            element: document.getElementsByClassName("tourThreatCol"),
            last: false,
        },
        5: {
            step: 5,
            title: "Benefits of Being In Scope",
            placement: "left",
            content: <>
                <p>Vectors Out of Scope will not be tested,
                    but you won't get credit for underlying controls that may benefit your BreachRisk™ Score.
                </p>
                <p>All new threats are In Scope by default. Vectors In Scope will be tested if you have Penetration Testing enabled.</p>
            </>,
            anchorEl: "#tourStepThreatScope",
            scrollToElement: false,
            element: document.getElementsByClassName("tourThreatCol"),
            last: false,
        },
        2: {
            step: 2,
            title: "Testing Status",
            placement: "left",
            content: <>
                <p>From a hacker's perspective, each threat goes through four phases: identified, verified, tested, and breached.
                    Enabling penetration testing will allow us to verify, test, and safely attempt to breach each vector -- just like an attacker would.
                </p>
                <p>This allows you to see how your defenses are holding up.</p>
            </>,
            anchorEl: "#tourStepThreatHeader",
            scrollToElement: false,
            element: document.getElementsByClassName("tourThreatStatusCol"),
            last: false,
        },
        9: {
            step: 9,
            title: "Your Cyberspace — Attack Surface",
            placement: "bottom-right",
            content: "See what your cyberspace looks like from the attacker's perspective. Find overviews, trends, and detailed graphs below.",
            anchorEl: "#tourStepYourCyberSpace",
            scrollToElement: null,
            // element: document.getElementsByClassName("tourStepBRVulnsTable"),
            last: false,
        },
        // 10: {
        //     step: 10,
        //     title: "Track Trends",
        //     content: "See how your visible infrastructure has changed over time.",
        //     anchorEl: "#tourStepCyberSpaceTrends",
        //     placement: "top-start",
        //     scrollToElement: document.querySelector("#tourStepCyberSpaceTrendsScrollHeader"),
        //     // element: document.getElementsByClassName("tourStepBRVulnsTable"),
        //     last: false,
        // },
        10: {
            step: 10,
            title: "Active Hosts Detected",
            content: "This table lists hosts that hackers can see. Each host potentially provides opportunity to an attacker." +
                " Making sure these are accurate and up to date with your own records keeps your company more secure.",
            anchorEl: "#tourStepAllSystemTargetsTable",
            placement: "top-center",
            scrollToElement: "#tourTechTargetsTable",
            // element: document.getElementsByClassName("tourStepBRVulnsTable"),
            last: false,
        },
        // 10: {
        //     step: 10,
        //     title: "Common Vunerabilities",
        //     content: "Just showing off the scroll ability",
        //     anchorEl: "#tourSubdomainsTable",
        //     scrollToElement: document.querySelector("#tourServicesTable"),
        //     // element: document.getElementsByClassName("tourStepBRVulnsTable"),
        //     last: false,
        // },
        // 11: {
        //     step:       11,
        //     title: "Common Vunerabilities",
        //     content: "Just showing off the scroll ability",
        //     anchorEl: "#tourStepBRVulnsTable",
        //     scrollToElement: document.querySelector("#tourStepBRVulnsTable"),
        //     // element: document.getElementsByClassName("tourStepBRVulnsTable"),
        //     last: false,
        // },
        11: {
            step: 11,
            title: "Common Vulnerabilities Detected",
            content: <>
                Find out more about any Common Vulnerabilities in your infrastructure.
                CVE's are not an exhaustive or inclusive list of threats, but a measure corresponding to the <BBExternalLink tipText={"Visit the NVD at nvd.nist.gov"} href={"https://nvd.nist.gov/"} className={"text-white"}> National Vulnerability Database (NVD)</BBExternalLink>. Find links for each vulnerability in the associated table.
                </>,
            anchorEl: "#tourStepBRVulnerabilitiesTable",
            scrollToElement: "#tourStepBRVulnsTable",
            // element: document.getElementsByClassName("tourStepBRVulnsTable"),
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: 400,
        // height: 250,
        background: 'white',
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}

export default BRfBizInitialTourTechnical;